'use client'
import React, { useState } from 'react';
import styles from './recent-sales.module.scss';
import Image from 'next/image';
import { images } from 'sdk';
import Container from '~/components/layout/container';
import { Box } from '~/components/layout/box';
import Text from '@/components/typography/text';
import Heading from '@/components/typography/heading';
import Button from '~/components/button';

interface Sale {
  id: string;
  isbn: string;
  time_created: string;
  amount: number;
  condition: string;
  format: string;
  photos: string[];
}

interface RecentSalesProps {
  data: Sale[];
}

export default function RecentSales({ data }: RecentSalesProps) {
  
  const PageSize = 25;
  const [visibleSales, setVisibleSales] = useState(PageSize);

  const handleLoadMore = () => {
    setVisibleSales((prev) => prev + PageSize);
  };

  const paginatedSales = data.slice(0, visibleSales);

  return (
    <Container>
      <Heading size='large' style={{ marginBottom: '1rem' }}>Recent Sales</Heading>
      <Box className={styles.container}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Book</th>
              <th>Price</th>
              <th>Condition</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedSales.map((sale) => (
              // TODO: replace onclick with Link - getting errors.
              <tr 
                key={sale.id} 
                onClick={() => {
                  window.open(`/books/${sale.id}`, '_blank');
                }}
                className={styles.tableRow}
              >
                <td>
                  <div className={styles.imageCell}>
                    {sale?.photos[0] ? (
                      <Image
                        src={images(sale.photos[0]).book.thumb}
                        unoptimized
                        alt={`Sale image for ${sale.id}`}
                        width={50}
                        height={50}
                        className={styles.image}
                      />
                    ) : (
                      <div className={styles.noImage}>No Image</div>
                    )}
                  </div>
                </td>
                <td>
                  <Text size='large'>${(sale?.amount / 100).toFixed(2)}</Text>
                </td>
                <td>
                  <Text size="medium">{sale?.condition}</Text>
                </td>
                <td>
                  <Text size="medium">
                    {new Date(sale?.time_created).toLocaleDateString('en-US')}
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {visibleSales < data.length && (
          <div className={styles.loadMoreContainer}>
            <Button 
              text="Show More" 
              onPress={handleLoadMore} 
              style="secondary"
              className={styles.loadMoreButton} 
            />
          </div>
        )}
      </Box>
    </Container>
  );
};

